"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
var _locales = require("../utils/locales");
const messages = exports.messages = {
  [_locales.locales.en]: "Notification",
  [_locales.locales.es]: "Notificaciones",
  [_locales.locales.fr]: "Notifications",
  [_locales.locales.pt]: "Notificações",
  [_locales.locales.zh]: "通知",
  [_locales.locales.de]: "Benachrichtigungen",
  [_locales.locales.it]: "Notifiche",
  [_locales.locales.ja]: "通知",
  [_locales.locales.hi]: "सूचनाएं",
  [_locales.locales.tl]: "Mga abiso",
  [_locales.locales.ko]: "알림"
};